import useSWR from "swr";
import { apiBaseURL } from "../../Utils/ProjectConstants";

export default function useGetEmployeesOfTheMonth() {
  const { data, error, mutate, isLoading } = useSWR(
    `${apiBaseURL}/api/EmployeeOfTheMonth`,
    {
      revalidateOnFocus: false,
      dedupingInterval: 300000, // 5 min
    }
  );

  // Normalize/sort
  const items = Array.isArray(data?.data) ? data.data : [];
  const sorted = items
    .map((x) => ({ ...x, _ts: new Date(x.month).getTime() || 0 }))
    .sort((a, b) => b._ts - a._ts);

  const current = sorted.find((r) => r.isCurrent) ?? sorted[0] ?? null;

  return {
    items: sorted,
    current,
    raw: data,
    mutate,
    isLoading,
  };
}
